import React from 'react';
import styled from 'styled-components';
import clsx from 'clsx';
import SvgAlertFilled from '../Icon/SvgAlertFilled';
import SvgSuccessFilled from '../Icon/SvgSuccessFilled';
import Typography from '../Typography';
const FormControlHelpTextSC = styled.div `
  user-select: none;
  margin-top: 0.25rem;
  display: flex;
  flex-direction: column;

  ._ndsFormControlHelpText__validation {
    margin-top: 4px;
    padding-left: 0.75rem;
    display: flex;
    align-items: center;
  }

  ._ndsFormControlHelpText__message {
    display: flex;
    align-items: center;
    color: ${(p) => p.theme.ColorFontInputLabelBase};
  }

  ._ndsFormControlHelpText__icon {
    fill: ${(props) => props.theme.ColorIconInputLabelBase};
    margin-right: 0.25rem;
    flex-shrink: 0;
  }

  /* error */
  ._ndsFormControlHelpText__message--error {
    color: ${(props) => props.theme.ColorFontInputLabelError};
  }
  ._ndsFormControlHelpText__icon--error {
    fill: ${(props) => props.theme.ColorIconInputLabelError};
  }

  /* valid */
  ._ndsFormControlHelpText__message--valid {
    color: ${(props) => props.theme.ColorFontInputLabelBase};
  }
  ._ndsFormControlHelpText__icon--valid {
    fill: ${(props) => props.theme.ColorIconInputLabelSuccess};
  }

  /*disabled*/
  ._ndsFormControlHelpText__message--disabled {
    color: ${(props) => props.theme.ColorFontInputLabelDisabled};
  }
  ._ndsFormControlHelpText__icon--disabled {
    fill: ${(props) => props.theme.ColorIconInputLabelDisabled};
  }
`;
const getMessageIcon = (isValid, isError) => {
    if (isError) {
        return isValid ? SvgSuccessFilled : SvgAlertFilled;
    }
    return SvgSuccessFilled;
};
const getMessageClasses = (isError, isDisabled, isValid = false) => {
    return clsx('_ndsFormControlHelpText__message', { '_ndsFormControlHelpText__message--error': isError }, { '_ndsFormControlHelpText__message--disabled': isDisabled }, { '_ndsFormControlHelpText__message--valid': isValid });
};
const getIconClasses = (isError, isDisabled, isValid = false) => {
    return clsx('_ndsFormControlHelpText__icon', { '_ndsFormControlHelpText__icon--error': isError }, { '_ndsFormControlHelpText__icon--disabled': isDisabled }, { '_ndsFormControlHelpText__icon--valid': isValid });
};
const FormControlHelpText = (props) => {
    const { helpText, helpTextId, disabled, error } = props;
    const classes = clsx('_ndsFormControlHelpText');
    if (!helpText) {
        return null;
    }
    if (typeof helpText === 'object' && (helpText.title || helpText.validations)) {
        const { title, validations = [] } = helpText;
        const toRenderValidations = validations.filter((v) => Boolean(v.message));
        return (React.createElement(FormControlHelpTextSC, { className: classes, id: helpTextId },
            title && (React.createElement(Typography, { as: "span", className: getMessageClasses(error, disabled), variant: "body4" }, title)),
            toRenderValidations.map((v) => {
                const MessageIcon = getMessageIcon(v.isValid, error);
                return (React.createElement("div", { className: "_ndsFormControlHelpText__validation", key: v.message },
                    React.createElement(Typography, { as: "span", className: getMessageClasses(error && !v.isValid, disabled, v.isValid), variant: "body4" },
                        React.createElement(MessageIcon, { size: "s", className: getIconClasses(error && !v.isValid, disabled, v.isValid) }),
                        v.message)));
            })));
    }
    return (React.createElement(FormControlHelpTextSC, { className: classes },
        React.createElement(Typography, { as: "span", id: helpTextId, className: getMessageClasses(error, disabled), variant: "body4" },
            error && React.createElement(SvgAlertFilled, { size: "s", className: getIconClasses(error, disabled) }),
            ' ',
            helpText)));
};
export default FormControlHelpText;
//# sourceMappingURL=FormControlHelpText.js.map